import React from 'react';
import classNames from 'classnames';
import { getRenderable } from '@fiverr-private/fit';

import { ModalLayoutProps } from '../types';
import styles from './index.module.scss';

const ModalLayout: React.FC<ModalLayoutProps> = ({ children, className, centered = false }) => (
    <div className={classNames('flex flex-col', styles.layout, className)}>
        {React.Children.map(children, (child: any) => getRenderable(child, { centered }))}
    </div>
);

ModalLayout.displayName = 'ModalLayout';

export default ModalLayout;
